import { PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from 'app/auth';
import { ROUTES } from '../consts';

export const AnalyticsProtectedRoute = ({ children }: PropsWithChildren) => {
  const { isOrganizationOwner } = useContext(AuthContext);

  if (!isOrganizationOwner) {
    console.warn('user is not an organization owner');

    return <Navigate to={ROUTES.ROOT} />;
  }

  return <>{children}</>;
};
